export const safetyItems = [
    {
        type: 'breathing',
        img: 'mask-icon',
        isSelected: true
    },
    {
        type: 'hearing',
        img: 'headphones',
        isSelected: false
    },
    {
        type: 'head_safety',
        img: 'helmet',
        isSelected: true
    },
    {
        type: 'eye_safety',
        img: 'eye-wear',
        isSelected: false
    },
    {
        type: 'foot_safety',
        img: 'shoe',
        isSelected: false
    },
    {
        type: 'hand_safety',
        img: 'gloves',
        isSelected: false
    },
    {
        type: 'body_safety',
        img: 'safety-suit',
        isSelected: false
    },
]